import { render, staticRenderFns } from "./update-event-data-screen.html?vue&type=template&id=159cfec4&scoped=true&external"
import script from "./update-event-data-screen.js?vue&type=script&lang=js&external"
export * from "./update-event-data-screen.js?vue&type=script&lang=js&external"
import style0 from "./update-event-data-screen.scss?vue&type=style&index=0&id=159cfec4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cfec4",
  null
  
)

export default component.exports